function initLazyImages() {
  const lazyImages = document.querySelectorAll("img.lazy-image");

  lazyImages.forEach((img) => {
    if (img.dataset.image) {
      const newImage = new Image();
      newImage.onload = function () {
        img.src = this.src;
        img.classList.add("loaded-image");
        img.classList.remove("lazy-image");
      };
      newImage.src = img.dataset.image;
    }
  });
}

document.addEventListener("DOMContentLoaded", initLazyImages);
